// extracted by mini-css-extract-plugin
module.exports = {"team":"_828c50f","name":"_3616b64"};